import { registerQuery, useQuery } from 'data-fetching-client';
import { convertFieldValueAvroToJson } from 'rpc-client-utils';

import { AppContextType } from '../types';

import { useGetDraftListingQuery } from '../../__generated__/chirp/com/hubspot/marketplace/listing/details/rpc/MarketplaceListingEditorRpc.hooks';
import { getDraftListing } from '../clients/internalPreviewClient';

const GET_DRAFT_LISTING_INTERNAL = registerQuery({
  fieldName: 'draftListing',
  args: ['listingId'],
  fetcher: getDraftListing,
});

interface UseListingPreviewProps {
  appContext?: AppContextType;
  listingId?: number;
  language?: string;
  skip?: boolean;
}

export function useListingPreview({
  appContext,
  listingId,
  language,
  skip,
}: UseListingPreviewProps) {
  const { data, loading, error } = useGetDraftListingQuery({
    variables: { listingId: listingId || 0, language: language || 'en' },
    skip: skip || !listingId || appContext === 'admin-preview',
  });

  const {
    data: internalData,
    loading: internalLoading,
    error: internalError,
  } = useQuery(GET_DRAFT_LISTING_INTERNAL, {
    variables: { listingId: listingId || 0, language: language || 'en' },
    skip: skip || !listingId || appContext !== 'admin-preview',
  });

  // @ts-ignore untyped BE response
  const parsedUnifiedDetailsData: Record<string, any> =
    data?.listing || internalData?.draftListing.listing
      ? convertFieldValueAvroToJson(
          appContext !== 'admin-preview'
            ? data?.listing
            : internalData?.draftListing.listing
        )
      : {};

  return {
    previewData: listingId ? parsedUnifiedDetailsData : null,
    previewLoading: loading || internalLoading,
    previewError: error || internalError,
  };
}
